import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import tooltip from "../../Assets/tooltip-icon.png";
import upload from "../../Assets/svg/upload-icon.svg";
import plus from "../../Assets/svg/plus.svg";
import DocUpload from "../modules/DocUpload";
import { useDispatch, useSelector } from "react-redux";
import { addIncomeInfo } from "./redux/actions";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import StaticItem from "../modules/StaticItem";
import Button from "../modules/Button";
import GradientLoader from "../modules/Loader";
import ModalComponent from "../modules/Modal";

export default function IncomeTop(props) {
  const dispatch = useDispatch();
  const [err, showErr] = useState(false);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const [names, setNames] = useState([
    "Myself",
    "My Father",
    "My Mother",
    "Sibling1",
    "Sibling2",
    "Sibling3",
    "My Guardian",
    "No-one",
  ]);
  const incomeInfo = useSelector(
    (state) => state.income.incomeInfo.membersList
  );
  const [uploading, setUploading] = useState(false);
  const [doc, setDoc] = useState(null);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [alert, setAlert] = useState(false);
  const toolTipData = () => {
    return (
      <div className="tool-tip-div">
        <div className="tool-tip-title">Verification Document</div>
        <div className="ul-div">
          Upload one of the following:
          <ul>
            <li>No-Income Certificate</li>
            <li>Orphan Certificate</li>
          </ul>
        </div>
      </div>
    );
  };
  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      props.showModal("File with double extensions is not allowed.");
      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const addData = (value) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "application/msword",
      ".doc",
      ".docx",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (value) {
      let isFormat = false;
      for (let i in allowedTypes) {
        if (value.type === allowedTypes[i]) {
          isFormat = true;
        }
      }
      if (!isFormat) {
        value = null;
        // console.log("doc.type", value.type);
        alert("Only PDF, JPEG, PNG, and Word files are allowed.");
        //   setDoc(null); // Clear the file input
      } else if (value !== null && value.size / 1024 / 1024 > 2) {
        value = null;
        alert(" File size exceeds the maximum upload size limit.");
        // showErr(true)
        // setTimeout(() => showErr(false), 3000);
      }
    }
    value = validateFileName(value);
    // return e;
    setDoc(value);
    // console.log('income dispatch here', incomeInfo)
    dispatch(addIncomeInfo([{ ...incomeInfo[0], document: value }]));
  };
  const checkFamily = (data) => {
    props.onChange(data);
  };

  const getDocs = async () => {
    const docs2 = await api.getDocuments(
      "application",
      tokenData?.applicationData.id,
      tokenData?.token
    );
    dispatch(addTokenInfo(["docs", docs2.data]));
  };
  const delDoc = async (type, e) => {
    addData(e);
    let file;
    if (docs) {
      file = docs[`noIncomeCertificate`];
    }
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", e);
      formData.append("name", e.name);
      formData.append("size", e.size);
      formData.append("documentType", `noIncomeCertificate`);
      formData.append("fileType", e.type.split("/")[1]);
      if (file) {
        formData.append("id", file.id);
      }
      const result = await api.uploadDocument(
        "application",
        tokenData.applicationData.id,
        tokenData.token,
        formData
      );
      if (result?.statusCode == 200) {
        props.showModal("Your Document has been uploaded successfully!")

        // setAlertType({
        //   ...alertType,
        //   msg: "Your Document has been uploaded successfully!",
        // });
        // setAlert(true);
        // setTimeout(() => setAlert(false), 3000);
      }
      getDocs();
      addData(e);
      setUploading(false);
    } catch (error) {
      alert("Sorry! Something went wrong, Please try again.");
      console.error("Error uploading document:", error);
      setUploading(false);
    }
  };
  const handleUpload = async (e) => {
    e=validateFileName(e)
    if(e){
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", `noIncomeCertificate`);
        formData.append("fileType", e.type.split("/")[1]);
        const result = await api.uploadDocument(
          "application",
          tokenData.applicationData.id,
          tokenData.token,
          formData
        );
        getDocs();
        setUploading(false);
      } catch (error) {
        alert("Sorry! Something went wrong, Please try again.");
        console.error("Error uploading document:", error);
        setUploading(false);
      }
    }
  };
  const setRole = (role) => {
    if (role !== "") {
      if (["Mother", "Father", "Guardian"].includes(role)) {
        role = "My " + role;
      }
    }
    // console.log('role', role)
    return role;
  };
  const getList2 = (data) => {
    let list = [];
    data.forEach((element) => {
      list = [...list, setRole(element.relationShipType)];
    });
    if (list?.length === 0) {
      list = props.list || [];
    }
    return list;
  };
  useEffect(() => {
    // console.log("members", incomeInfo);
    if (personalInfo.orphan === "Yes") {
      let list = names.filter((a) => a!== "My Father" && a!== "My Mother");
      let members = incomeInfo?.filter((b) => b.relationShipType !== "Mother" && b.relationShipType !== "Father");
      
      dispatch(addIncomeInfo(members));

      setNames([...list]);
    }
    // console.log("list on load", props.list, incomeInfo?.membersList);
  }, []);
  // console.log('props.list', props.list, props.list2, getList2(props.list2))
  return (
    <div className="income-top">
      <div className="field-left income-field-set">
        {/* <DropBtn title={"Select the earning members of your family"} /> */}
        <MultiSelect
          list={props.list}
          names={names}
          type={"income"}
          getList={getList2(props.list2)}
          onChange={(e) => checkFamily(e)}
          title={"Select the earning members of your family"}
        />
      </div>
      <div className="field-right income-field-set">
        {props.list2 &&
          props.list2[0]?.relationShipType?.includes("No-one") && (
            <>
              {docs && docs[`noIncomeCertificate`] ? (
                <StaticItem
                  onDelete={(e) => delDoc("noIncomeCertificate", e)}
                  type={"doc"}
                  doc={docs[`noIncomeCertificate`]}
                  isEditable={true}
                  title={"No income certificate"}
                  docUrl={docs[`noIncomeCertificate`]?.documentUrl}
                  value={docs[`noIncomeCertificate`]?.name}
                  size={Math.floor(docs[`noIncomeCertificate`]?.size / 1024)}
                />
              ) : (
                <div className="file-upload-container">
                  <DocUpload
                    title={" Verification Document"}
                    noTooltip={false}
                    tooltipContent={toolTipData()}
                    value={doc?.name ? doc : null}
                    onChange={(e) => handleUpload(e)}
                  />
                  {/* {doc && (
                    <Button
                      className="upload-button"
                      onClickHandler={() => handleUpload()}
                      disabled={uploading}
                      value={
                        uploading ? <span className="spinner"></span> : "Upload"
                      }
                      type={"contained"}
                    />
                  )} */}
                </div>
              )}
              {err && (
                <p className="set-sub-title">
                  File size exceeds the maximum upload size limit.
                </p>
              )}
              {/*            {" "}
            <DocUpload
              tooltipContent={toolTipData()}
              value={incomeInfo[0]?.document || null}
              onChange={(e) => addData(e)}
              title={" Verification Document"}
            />
             {err && (
            <p className="set-sub-title">
              File size exceeds the maximum upload size limit.
            </p>)}*/}
            </>
          )}
      </div>
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}
